import { render } from "./CodeInstructions.vue?vue&type=template&id=6e475416"
import script from "./CodeInstructions.vue?vue&type=script&lang=js"
export * from "./CodeInstructions.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__